import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useSummaryContext } from '../../../../../SummaryContext'
import RenderedCell from './components/RenderedCell'
import { GoogleSheetRecord } from '../GoogleSheetRecord'

export function useExpand(): ExpandOptions<GoogleSheetRecord> | undefined {
  const { selected } = useSummaryContext()
  if (!selected || selected.__typename === 'ProjectToInternalConnection') return
  return {
    render: (record) => ({
      additionalInfo: record.map(({ header, ...cell }) => ({
        type: 'default',
        label: header.formattedValue,
        hidden: header.visible,
        children: <RenderedCell key={cell.id} {...cell} />,
      })),
    }),
    expandable: ({ someInvisible }) => someInvisible,
  }
}
